(() => {
  const D = window.Dallas || {};
  const strings = D.strings || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const root = $('[data-product-root]');
  if (!root) return;

  const variantIdInput = $('[data-variant-id]', root);
  const priceEl = $('[data-product-price]', root);
  const compareEl = $('[data-product-compare]', root);
  const addBtn = $('[data-add-to-cart]', root);
  const expressWrap = $('[data-express-checkout]', root);
  const errorEl = $('[data-product-error]', root);

  const optionRows = $$('[data-option]', root);
  const slides = $$('[data-media-slide]', root);
  const thumbs = $$('[data-media-thumb]', root);

  const qtyValue = $('[data-qty-value]', root);
  const qtyInput = $('[data-quantity]', root);
  const qtyMinus = $('[data-qty-minus]', root);
  const qtyPlus = $('[data-qty-plus]', root);

  let variants = [];
  try {
    const data = $('[data-variants-json]', root);
    variants = data ? JSON.parse(data.textContent) : [];
  } catch (_) {
    variants = [];
  }
  const hasVariantData = variants.length > 0;

  const findVariant = () => {
    const selected = optionRows.map((row) => {
      const active = row.querySelector('[data-option-value].is-active');
      return active ? active.dataset.optionValue : null;
    });
    if (!selected.length || selected.some((v) => !v)) return null;
    return (
      variants.find((v) => {
        const opts = v.options || [];
        if (opts.length !== selected.length) return false;
        return opts.every((opt, i) => String(opt).trim() === String(selected[i]).trim());
      }) || null
    );
  };

  const showSlide = (mediaId) => {
    if (!mediaId) return;
    slides.forEach((s) => s.classList.toggle('is-active', String(s.dataset.mediaSlide) === String(mediaId)));
    thumbs.forEach((t) => t.classList.toggle('is-active', String(t.dataset.mediaThumb) === String(mediaId)));
  };

  const setQuantity = (value, max) => {
    if (!qtyValue || !qtyInput) return;
    const parsed = parseInt(value, 10);
    let next = isNaN(parsed) ? 1 : parsed;
    if (typeof max === 'number' && max >= 1) next = Math.min(next, max);
    next = Math.max(1, next);
    qtyValue.textContent = String(next);
    qtyInput.value = String(next);
    if (qtyMinus) qtyMinus.disabled = next <= 1;
    if (qtyPlus) qtyPlus.disabled = typeof max === 'number' && max >= 1 && next >= max;
  };

  const update = (variant) => {
    const available = variant ? variant.available : false;

    if (variant) {
      if (priceEl) priceEl.textContent = variant.price_money || '';
      if (compareEl) {
        if (variant.compare_money) {
          compareEl.textContent = variant.compare_money;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (variant.featured_media_id) showSlide(variant.featured_media_id);
    }

    const maxQty =
      variant && variant.inventory_management && variant.inventory_policy === 'deny'
        ? Number(variant.inventory_quantity)
        : Infinity;

    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.textContent = available
        ? strings.addToCart || 'Ajouter au panier'
        : strings.soldOut || 'Rupture';
    }
    if (expressWrap) expressWrap.hidden = !available;
    setQuantity(qtyValue ? qtyValue.textContent : '1', maxQty);
  };

  /* ---------- Option selection ---------- */
  optionRows.forEach((row) => {
    row.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      row.querySelectorAll('[data-option-value]').forEach((b) => {
        const active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', String(active));
      });
      if (errorEl) errorEl.hidden = true;
      const variant = findVariant();
      if (variant) {
        if (variantIdInput) variantIdInput.value = variant.id;
        update(variant);
      } else if (hasVariantData) {
        if (variantIdInput) variantIdInput.value = '';
        update(null);
      }
    });
  });

  /* ---------- Gallery ---------- */
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => showSlide(thumb.dataset.mediaThumb));
  });

  /* ---------- Quantity ---------- */
  if (qtyMinus) {
    qtyMinus.addEventListener('click', () =>
      setQuantity(parseInt(qtyValue ? qtyValue.textContent : '1', 10) - 1),
    );
  }
  if (qtyPlus) {
    qtyPlus.addEventListener('click', () =>
      setQuantity(parseInt(qtyValue ? qtyValue.textContent : '1', 10) + 1),
    );
  }

  /* ---------- Init ---------- */
  const current = variants.length ? (optionRows.length ? findVariant() : variants[0]) : null;
  if (current) {
    if (variantIdInput) variantIdInput.value = current.id;
    update(current);
  } else if (hasVariantData && optionRows.length) {
    update(null);
  }
})();
